import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { EditNumber } from '../../../../../../component/ui/edit-text/edit-number';
import { AbstractExternalExam } from '../../../../../../api/types/settings/studies/abstract-external-exam';

export interface ExamInForm {
  externalExam: AbstractExternalExam;
  startAt: Date | null;
  durationMinutes: number;
  studentRegistrationDueDate: Date | null;
  paymentServiceId: number | null;
  paymentServiceVersionId: number | null;
}

interface EditExamInFormDialogProps {
  exam: ExamInForm;
  visible: boolean;
  onHide: () => void;
  onUpdate: (updates: Partial<ExamInForm>) => void;
}

export const EditExamInFormDialog: React.FC<EditExamInFormDialogProps> = ({
  exam,
  visible,
  onHide,
  onUpdate,
}) => {
  return (
    <Dialog
      header={`הגדרות מבחן: ${exam.externalExam.examName}`}
      visible={visible}
      onHide={onHide}
      style={{
        width: '600px',
        backgroundColor: 'white',
        padding: '8px',
        borderRadius: '8px',
      }}
      modal
    >
      <div style={{ direction: 'rtl', padding: '8px' }}>
        <div style={{ marginBottom: '16px' }}>
          <label
            style={{
              fontSize: '14px',
              color: '#4b5563',
              marginBottom: '8px',
              display: 'block',
            }}
          >
            תאריך ושעת התחלה
          </label>
          <Calendar
            value={exam.startAt}
            onChange={(e) =>
              onUpdate({
                startAt: e.value as Date,
              })
            }
            showTime
            hourFormat="24"
            dateFormat="dd/mm/yy"
            style={{ width: '100%' }}
            inputStyle={{ direction: 'rtl', textAlign: 'right' }}
            panelStyle={{ direction: 'ltr' }}
          />
        </div>

        <EditNumber
          title="משך הבחינה (דקות)"
          value={exam.durationMinutes}
          onChange={(value) =>
            onUpdate({
              durationMinutes: value,
            })
          }
          min={1}
        />

        <div style={{ marginBottom: '16px' }}>
          <label
            style={{
              fontSize: '14px',
              color: '#4b5563',
              marginBottom: '8px',
              display: 'block',
            }}
          >
            תאריך אחרון לרישום
          </label>
          <Calendar
            value={exam.studentRegistrationDueDate}
            onChange={(e) =>
              onUpdate({
                studentRegistrationDueDate: e.value as Date,
              })
            }
            dateFormat="dd/mm/yy"
            style={{ width: '100%' }}
            inputStyle={{ direction: 'rtl', textAlign: 'right' }}
            panelStyle={{ direction: 'ltr' }}
          />
        </div>

        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: '8px',
            marginTop: '20px',
          }}
        >
          <Button label="סגור" severity="secondary" onClick={onHide} />
        </div>
      </div>
    </Dialog>
  );
};
